exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-custom[data-v-3e39af80]{background-color:#fff;max-width:800px;padding:30px 20px;height:100vh}", ""]);

// exports
